import * as React from "react";
const SvgFiBrandsFirefoxBrowser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-firefox-browser_svg__a)">
      <path
        fill="#151A2D"
        d="M23.725 8.049c-.526-1.216-1.593-2.528-2.43-2.943.681 1.282 1.076 2.569 1.227 3.529l.002.019c-1.37-3.277-3.693-4.599-5.59-7.476-.096-.146-.191-.291-.285-.445a4 4 0 0 1-.133-.241 2 2 0 0 1-.18-.46c0-.016-.012-.029-.028-.031a.04.04 0 0 0-.023 0l-.006.003a1 1 0 0 0-.07.035C13.63 1.523 12.5 4.076 12.18 5.856a6.7 6.7 0 0 0-2.4.588.29.29 0 0 0-.153.369.31.31 0 0 0 .386.181l.027-.01a6.4 6.4 0 0 1 2.46-.539 6.2 6.2 0 0 1 3.222.867 6.1 6.1 0 0 1 2.119 2.104c-.647-.436-1.806-.867-2.921-.681 4.357 2.091 3.187 9.292-2.85 9.02a5.4 5.4 0 0 1-2.137-.525c-1.479-.734-2.7-2.121-2.853-3.805 0 0 .56-2 4.004-2 .372 0 1.437-.997 1.457-1.287-.005-.095-2.113-.9-2.935-1.677-.44-.416-.649-.616-.833-.766a4 4 0 0 0-.314-.228 5.2 5.2 0 0 1-.034-2.842c-1.781.787-2.922 2.163-2.922 2.163-.48-.583-.446-2.51-.419-2.912-.005-.025-.358.176-.404.206q-.637.436-1.183.974a10 10 0 0 0-1.131 1.302l-.002.002.002-.002A9.6 9.6 0 0 0 .74 9.881a13 13 0 0 0-.328 2.19q-.008.151-.009.302C.403 18.794 5.826 24 12.517 24c5.991 0 10.965-4.175 11.94-9.66q.029-.223.054-.449c.241-1.993-.027-4.089-.786-5.842"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-firefox-browser_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsFirefoxBrowser;
